<template>
  <div class="date-select">
    <InputSelect v-model="birthDay" :message="errorMessage" placeholder="Giorno" :state="errorState">
      <option v-for="i in 31" :key="i">{{ i }}</option>
    </InputSelect>
    <InputSelect v-model="birthMonth" placeholder="Mese">
      <option v-for="i in 12" :key="i">{{ i }}</option>
    </InputSelect>
    <InputSelect v-model="birthYear" placeholder="Anno">
      <option v-for="year in years" :key="year">{{ year }}</option>
    </InputSelect>
  </div>
</template>

<script>
import InputSelect from "@/components/elements/InputSelect";
import getBirthDate from "../helpers/getBirthDate";
import dateCheck from "../helpers/dateCheck";

export default {
  name: "DateSelect",
  components: { InputSelect },
  props: {
    needCheck: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      birthDay: null,
      birthMonth: null,
      birthYear: null,
      birthDate: null,
      errorMessage: "",
    };
  },
  computed: {
    errorState() {
      if (this.errorMessage) {
        return "error";
      }
      return "";
    },
    years() {
      const year = new Date().getFullYear();
      return Array.from({ length: year - (year - 70) }, (value, index) => year - 69 + index);
    },
  },
  watch: {
    needCheck(check) {
      if (check) {
        this.updateDate();
        this.$emit("check-needed");
      }
    },
  },
  mounted() {
    const { day, month, year } = this.getBirthDate(this.user.birth_day, this.user.birth_month, this.user.birth_year);
    this.birthDate = `${year}-${month}-${day}`;
  },
  methods: {
    getBirthDate,
    updateDate() {
      this.birthDate = `${this.birthYear}-${this.birthMonth}-${this.birthDay}`;
      const date = new Date(this.birthDate);
      this.errorMessage = "";
      // eslint-disable-next-line no-restricted-globals
      if (date instanceof Date && !isNaN(date.valueOf())) {
        const age = dateCheck.calculateAge(this.birthDate);
        this.errorMessage = dateCheck.checkAge(this.user, age, this.$root.config.userAgeWarning);
        if (!this.errorMessage) {
          this.$emit("user-update", {
            birth_day: date.getDate(),
            birth_month: date.getMonth() + 1,
            birth_year: date.getFullYear(),
          });
        }
      } else {
        this.errorMessage = "La data inserita non è valida";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$date-input-width: 120px;

.date-select {
  @include media("<=s") {
    flex-wrap: wrap;
  }
  display: flex;

  .dea-input {
    @include media("<=s") {
      width: 100% !important; //sass-lint:disable-line no-important
    }
    margin-right: $space-small;
    width: $date-input-width !important; //sass-lint:disable-line no-important

    &__error-message {
      white-space: nowrap;
    }
  }
}
</style>
